import { cn } from '../../lib/utils'

const base =
  'inline-flex cursor-pointer items-center justify-center gap-2 rounded-2xl font-medium transition-all duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-45 active:scale-[0.98]'

const variants = {
  primary:
    'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 hover:shadow-md',
  secondary:
    'border border-border bg-card text-foreground shadow-sm hover:bg-muted hover:shadow-md',
  ghost: 'text-muted-foreground hover:bg-muted hover:text-foreground',
  danger:
    'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 hover:shadow-md',
}

const sizes = {
  sm: 'px-3.5 py-2 text-sm',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-5 py-3 text-base',
}

export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  type = 'button' as 'button' | 'submit' | 'reset',
  disabled = false,
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={cn(base, variants[variant], sizes[size], className)}
      {...props}
    >
      {children}
    </button>
  )
}
